/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class GetCodeModel {

        public enumName: string;
        public codeGroupId: string;
        public processConfigId: string;
        public isEnum: boolean;

        public equals(codeModel: GetCodeModel): boolean {
            if (this.isEnum) {
                return this.enumName === codeModel.enumName;
            } else {
                return this.codeGroupId === codeModel.codeGroupId &&
                    this.processConfigId === codeModel.processConfigId;
            }
        }

        public getName(): string {
            if (this.isEnum) {
                return this.enumName;
            }
            return this.codeGroupId;
        }
    }
}